export enum pathURL {
  LOGIN = 'login',
  FORGOT_PASSWORD = 'forgotPassword',
  RESET_PASSWORD = 'resetPassword',
  SIGN_UP = 'signup',
  TENANT = 'tenants',
  HOME = 'home',
  PAYMENTS = 'payments',
  INCIDENTS = 'incidents',
  ANOUNCEMENTS = 'anouncements',
  COMMUNICATIONS = 'communications',
  OWNER = 'owners',
  TRANSACTIONS = 'transactions',
  REPORTS = 'reports',
  OTP_VALIDATION = 'otpValidation',
  USER = 'user',
  CREATE = 'create',
  CONTACTS = 'contacts',
  SUPPLIER = 'suppliers',
  PROPERTY = 'properties',
  ESTATE = 'estate',
  CONTRACT = 'contracts',
  DETAIL = 'detail',
  CLIENT_FINDER = 'client-finder',
  RENT_CHARGES = 'rent-charges',
  EXPENSES = 'expenses',
  CONTRACTS_ROADMAP = 'contracts-roadmap',
  DEPOSITS = 'deposits',
  MANAGER_RATINGS = 'manager-ratings',
  ALERT_NOTICES = 'alert-notices',
}
